import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { MfuncErrorVal, GetDateHour, GetDateTime, openModalMensaje,  RecupPartesFchInicio, GlobalVars, GetDateTimeString, ConvertDateTimeToStr2, gvCanal, ValidarEmail, isNotEmpty, iconDescargar, CodTipoFichaFUR, CodSubTipoFichaOFI, DscNombreFileOficioFUR, RecupObjDatosPlant, saveContent2, isEmpty } from 'src/app/general/variables';
import { ErrorValidator } from 'src/app/models/personalizados/ErrorValidator';
import { Canal } from 'src/app/models/Canal';
import { CanalService } from 'src/app/services/canal.service';
import { Fur } from 'src/app/models/Fur';
import { EvidenciasComponent } from '../denuncia/evidencias/evidencias.component';
import { Observable } from 'rxjs';
import { FurService } from 'src/app/services/fur.service';
import { MatDialog } from '@angular/material/dialog';
import { Entidad } from 'src/app/models/Entidad';
import { BusqEntidadComponent } from '../general/busq-entidad/busq-entidad.component';
import { Catalogo } from 'src/app/models/Catalogo';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PlantillaDocumento } from 'src/app/models/PlantillaDocumento';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { ParametroPlantillaDocumento,  RecupUrlOficio, RecuperarGrillasPD } from 'src/app/general/Funciones';
import { General } from 'src/app/models/General';
import { DocumentoDet } from 'src/app/models/DocumentoDet';


@Component({
  selector: 'app-registro-documento',
  templateUrl: './registro-documento.component.html',
  styleUrls: ['./registro-documento.component.css']
})
export class RegistroDocumentoComponent implements OnInit {

  // trIdExpediente:string = "";
  strHoraReg: string  = GetDateHour()[1];
  strFechaRegistro: string = GetDateHour()[0];
  strDscEstado = 'Registrado';
  strDscUrlOfi = '';
  flgDeshabilitado = true;
  flgSoloLectura = false;
  flgViewDG = true;
  mFuncErrorVal: MfuncErrorVal = new MfuncErrorVal();
  errorValidator: ErrorValidator[] = [];
  listCanal: Canal[] = [];
  isEmpty = isEmpty;

  // strDscNombrPlantilla:string = "";
  // strDscNomArchivoGen:string = "";
  generalPD: General = new General();
  // listPdDatos:PDDatos[] = [];

  strNroRegistro: string;
  numIdCanal = 4;
  // strDscAsunto:string = "";
  strFchRecep = '';
  dateFchRecep: Date = null;
  // strDscRegOtr:string = "";//CFUR_DSCREGOTR //strDscRemitente:string = "";
  strDscRemitente = '';
  // strDscCorreo:string = "";
  strDscSumilla = '';
  strDscDetPrensa = '';
  strDscNomProg = '';
  strFurCodigo: string = null;
  strDscLabel1 = '';
  entidadFur: Entidad;
  listTipoRemitente: Catalogo[] = [];
  listTipCiudadano: Catalogo[] = [];
  listTipServControl: Catalogo[] = [];
  listTipoRedSoc: Catalogo[] = [];

  // dateFchRecep:Date = null;
  fur: Fur;
  flgRepPrensa = false;
  flgCorreoElec = true;
  // flgCarta = false;
  flgRegistrar = true;
  flgMesaPart = false;
  flgAppMovil = false;
  flgRedFisca = false;
  flgEmpresarios: boolean = null; // = false;
  flgMonitores = false;
  flgAudienciaPub = false;
  flgServControl = false;
  flgBD = false;
  FlgPostula = false;
  flgRedSocial = false;

  flgMostrarRemitente = true;
  flgMostrarSeccion1 = false;
  flgMostrarSeccion2 = false;

  strDscEtiqSecc1 = '';
  strDscEtiqSecc2 = '';
  strDscEtiqSecc3 = '';
  strDscEtiqSecc4 = '';
  strDscEtiqSecc5 = '';


  // Datos a Guardar
  dscRegotr: string;
  dscRegotr2: string;
  dscRegotr3: string;
  // numIdTipoRemitente:number = null;
  numIdNumOtr1: number = null;
  numIdTipDocExp: number = null; // nfurIdtipodocexp -- Tipo de Ciudadano

  strDscRegOtr3 = '';
  strDscRegOtr4 = '';
  strDscRegOtr5 = '';
  strDscRegOtr = '';
  strDscRegOtr2 = '';
  strCodUNO = ''; // entidad Remitente
  iconDescargar = iconDescargar;
  // strDscHecho : string = "";

  @ViewChild('busqEntidad1') busqEntidadC: BusqEntidadComponent;
  @ViewChild('busqEntidad2') busqEntidadRemitC: BusqEntidadComponent;
  // public dateControl = new FormControl(new Date(2021,9,4,5,6,7));

  @ViewChild(EvidenciasComponent) evidenciasC: EvidenciasComponent;
  @Output() opGuardadoOk = new EventEmitter();

  constructor(protected canalService: CanalService,
              protected furService: FurService,
              protected catalogoService: CatalogoService,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService,
              protected externosService: ExternosService,
              protected parametroPlantillaDocumento: ParametroPlantillaDocumento

    ) {

      this._setFlgEmpresarios(false);
      this._setEtiquetas(1);
      this._recupDatosPlantDocumento(1);
    }

  ngOnInit() {



    this.canalService.listarCanalDocumento().subscribe(data => {

      this.listCanal = data;

    });

    this.catalogoService.listarCatalogo(4).subscribe(data => {

      this.listTipoRemitente = data;

    });

    this.catalogoService.listarCatalogo(5).subscribe(data => {

      this.listTipCiudadano = data;

    });

    this.catalogoService.listarCatalogo(6).subscribe(data => {

      this.listTipServControl = data;

    });

    this.catalogoService.listarCatalogo(7).subscribe(data => {

      this.listTipoRedSoc = data;

    });

    setTimeout(() => {

      this.evidenciasC.setEvidenciaTitulo('Lista de archivos Adjuntos');
      this.evidenciasC.setStrDscColEtiq1('Descripción');

    }, 1);

  }

  _setEtiquetas(numCaso: number) {

    switch (numCaso) {
      case 1:

        this.strDscEtiqSecc2 = 'Fecha de Correo';
        this.strDscEtiqSecc3 = 'Asunto de Correo';
        this.strDscEtiqSecc4 = 'Detalle de Correo';

        break;

      case 2:

        this.strDscEtiqSecc2 = 'Fecha de Documento';
        this.strDscEtiqSecc5 = 'Sumilla de Documento';
        this.strDscEtiqSecc4 = 'Detalle de Documento';

        break;

      case 3:

        this.strDscEtiqSecc2 = 'Fecha';

        break;

      default:
        break;
    }

  }

  setFlgViewDG(valor: boolean) {

    this.flgViewDG = valor;

  }

  _setCodEntidadOut(entidadSelec: Entidad) {

    // console.log("=============_setCodEntidadOut");
    // console.log(entidadSelec);

    this.entidadFur = entidadSelec;

    // console.log("==============_setCodEntidadOut");

    this.ValidarDatos();

    // console.log("111111111111111==============_setCodEntidadOut");

  }

  _setCodEntidadRemitOut(entidadSelec: Entidad) {

    // console.log("=============entidadSelec.centCodigo");
    // console.log(entidadSelec.centCodigo);

    this.strCodUNO = entidadSelec.centCodigo; // this.busqEntidadC.getCodEntidad();

    this.ValidarDatos();

  }

  _setFlgEmpresarios(flgValor: boolean) {

    this.flgEmpresarios = flgValor;
    this.strDscLabel1 = (flgValor ? 'Empresa' : 'Nombre') + ' Remitente';

  }

  _CambioTipDocumento(numIdCanal: number) {

    // var ;
    let vNumCasoPD = 0;

    // if(event == null){return;}

    // console.log("=============event");
    // console.log(event);

    // var numIdCanal = idCanal//event.target.value;

    // console.log("=============numIdCanal");
    // console.log(numIdCanal);

    this.flgCorreoElec = false;
    this.flgRepPrensa = false;
    this.flgRedSocial = false;
    this.flgMesaPart = false;
    this.flgAppMovil = false;
    this.flgRedFisca = false;
    // this.flgEmpresarios = false;
    this._setFlgEmpresarios(false);
    this.flgMonitores = false;
    this.flgAudienciaPub = false;
    this.FlgPostula = false;
    this.flgBD = false;
    this.flgServControl = false;

    this.flgMostrarSeccion1 = false;
    this.flgMostrarSeccion2 = false;
    this.strDscEtiqSecc1 = '';
    this.strDscEtiqSecc2 = 'Fecha de Recepción';
    this.strDscEtiqSecc3 = 'Asunto';
    this.strDscEtiqSecc4 = 'Detalle';
    this.strDscEtiqSecc5 = 'Sumilla';


    // this.numIdCanal = null;
    this.numIdNumOtr1 = null;
    this.strDscRegOtr5 = '';
    // this.strDscRegOtr3 = "";
    // this.strDscAsunto = "";
    this.strDscRegOtr3 = '';
    this.strDscRegOtr4 = '';
    this.numIdTipDocExp = null;
    this.strDscRegOtr = '';
    this.strDscRegOtr2 = '';
    this.strFchRecep = '';
    this.entidadFur = null;
    this.strCodUNO = '';

    this.busqEntidadC.setEntidad('', true);

    // console.log("================this.busqEntidadC");
    // console.log(this.busqEntidadC.strDscEntidad)

    switch (Number(numIdCanal)) {
      case gvCanal.NumIdCorreo:

        this.flgCorreoElec = true;
        vNumCasoPD = 1;

        break;

      case gvCanal.NumIdRedSocial:

        // this.flgCarta = true;
        this.flgRedSocial = true;

        vNumCasoPD = 2;


        break;

      case gvCanal.NumIdReporte:

        this.flgRepPrensa = true;
        vNumCasoPD = 3;

        break;

      case gvCanal.NumIdMesaPartes:

        this.flgMesaPart = true;
        vNumCasoPD = 4;

        break;

      case gvCanal.NumIdAppMovil:

        this.flgAppMovil = true;
        vNumCasoPD = 5;

        break;


      case gvCanal.NumIdRedFis:

        this.flgRedFisca = true;
        vNumCasoPD = 6;

        setTimeout(() => {

          this.busqEntidadRemitC.setNumIdComponente(2);

        }, 1);


        break;

      case gvCanal.NumIdEmpresarios:

        // this.flgEmpresarios = true;
        this._setFlgEmpresarios(true);
        vNumCasoPD = 7;

        break;

      case gvCanal.NumIdMonitores:

        this.flgMonitores = true;
        vNumCasoPD = 8;

        break;

      case gvCanal.NumIdAudiencias:

        this.flgAudienciaPub = true;
        vNumCasoPD = 9;

        break;

      case gvCanal.NumIdPostula:

        this.FlgPostula = true;
        vNumCasoPD = 10;

        break;

      case gvCanal.NumIdBD:

        this.flgBD = true;
        vNumCasoPD = 11;

        break;

      case gvCanal.NumIdServicios:

        this.flgServControl = true;
        vNumCasoPD = 12;

        break;

      default:
        break;
    }

    this._recupDatosPlantDocumento(vNumCasoPD);

    // this.parametroPlantillaDocumento.recupParamPlantillaDoc(vNumCasoPD).subscribe(data=>{

    //   this.generalPD = data;

    // });

    this.flgMostrarRemitente = (this.flgCorreoElec || this.flgMesaPart || this.flgAppMovil || this.flgEmpresarios);

    // this.flgMostrarSeccion1 = (this.flgAudienciaPub || this.FlgPostula);

    if (this.flgAudienciaPub) {

      this.flgMostrarSeccion1 = true;

      this.strDscEtiqSecc1 = 'Número de Ficha Audiencias';
      // this.strDscEtiqSecc2 = "Fecha";
      this._setEtiquetas(3);

    } else if (this.FlgPostula) {

      this.flgMostrarSeccion1 = true;

      this.strDscEtiqSecc1 = 'Número de Ficha';

      this._setEtiquetas(2);
      this._setEtiquetas(3); // Fecha

    } else if (this.flgCorreoElec) {

      // this.strDscEtiqSecc2 = "Fecha de correo";
      // this.strDscEtiqSecc3 = "Asunto de correo";
      // this.strDscEtiqSecc4 = "Detalle de correo";

      this._setEtiquetas(1);

    } else if (this.flgRepPrensa) {

      this.strDscEtiqSecc2 = 'Fecha de Publicación';
      this.strDscEtiqSecc5 = 'Sumilla de Noticia';
      this.strDscEtiqSecc4 = 'Detalle de Noticia';

    } else if (this.flgRedSocial) {

      this.strDscEtiqSecc2 = 'Fecha de Publicación';
      this.strDscEtiqSecc5 = 'Sumilla de Publicación';
      this.strDscEtiqSecc4 = 'Detalle de Publicación';

    } else if (this.flgMesaPart) {

      this._setEtiquetas(2);

      // this.strDscEtiqSecc2 = "Fecha de Documento";
      // this.strDscEtiqSecc5 = "Sumilla de Documento";
      // this.strDscEtiqSecc4 = "Detalle de Documento";

    } else if (this.flgAppMovil || this.flgEmpresarios) {

      // this.strDscEtiqSecc2 = "Fecha";
      this._setEtiquetas(3);


    } else if (this.flgRedFisca) {

      this.flgMostrarSeccion2 = true;

      // this.strDscEtiqSecc2 = "Fecha de Documento";
      // this.strDscEtiqSecc5 = "Sumilla de Documento";
      // this.strDscEtiqSecc4 = "Detalle de Documento";
      this._setEtiquetas(2);


    } else if (this.flgMonitores) {

      this.flgMostrarSeccion2 = true;
      // this.strDscEtiqSecc2 = "Fecha";
      this._setEtiquetas(3);

    } else if (this.flgBD || this.flgServControl) {


      // this._setEtiquetas(2);
      this._setEtiquetas(3); // Fecha

    }

    this.ValidarDatos();

  }

  _recupDatosPlantDocumento(numCaso: number) {

    // console.log("========numCaso");
    // console.log(numCaso);


    this.parametroPlantillaDocumento.recupParamPlantillaDoc(numCaso).subscribe(data => {

      // console.log("========0this.generalPD");
      // console.log(this.generalPD);

      this.generalPD = data;

    });

  }





  dateChanged(event: any) {

    if (event.value) {

      // var date = new Date(event.value.toString());

      //  console.log("=================event.value.toString()");
      //  console.log(event.value.toString());

      // console.log("=================event.value");
      // console.log(event.value);

      // console.log("=================date.getMonth()");
      // console.log(GetDateTimeString(event.value.toString()));


      // this.strFchRecep = GetDateTimeString(event.value.toString());
      this.strFchRecep = event.value.toString();

      this.ValidarDatos();

    }


  }

  ValidarDatos() {

    // return;

    let FlgError = false;
    // var flgErrorCampo = false;
    // var flgValDatGen = false;
    // var dscCorreo = "";
    // var dscRemitente = "";
    // var dscSumilla = "";
    // var dscDetPrensa = "";
    // var dscNomProg = "";
    // var vNumIndex = 0;

    const vCodEntidad = this.busqEntidadC.getCodEntidad();

    // console.log("========calida");
    // console.log(vCodEntidad);
    // console.log(this.numIdNumOtr1);
    // console.log(this.strDscRegOtr);


    // console.log("===========validacion entidad");


    this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(vCodEntidad)), 'Ingrese la entidad', this.errorValidator, 0);

    // console.log("===========validacion entidad11111111111");
    // var dscMensaje = "";

    if (this.flgMostrarRemitente) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(this.numIdNumOtr1 != null), 'Ingrese el tipo remitente', this.errorValidator, 1);

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr5)), 'Ingrese el ' + this.strDscLabel1, this.errorValidator, 2);

    }

    if (this.flgCorreoElec) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr3) && ValidarEmail(this.strDscRegOtr3)), 'Ingrese el correo electrónico', this.errorValidator, 3);

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr4)), 'Ingrese el asunto', this.errorValidator, 4);

    }

    // if(this.flgRepPrensa)
    // {

    //   this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr3)), "Ingrese el nombre del programa",this.errorValidator,5);

    // }

    if (this.flgRedSocial) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(this.numIdNumOtr1 != null), 'Ingrese el tipo de red social', this.errorValidator, 6);
      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr3)), 'Ingrese el nombre del publicador', this.errorValidator, 7);

    }

    if (this.flgRedFisca) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strCodUNO)), 'Ingrese la entidad remitente', this.errorValidator, 8);
      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr3)), 'Ingrese el funcionario remitente', this.errorValidator, 9);
      // this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr4)), "Ingrese el cargo del remitente",this.errorValidator,10);

    }

    if (this.flgEmpresarios) {

      // this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr3)), "Ingrese la empresa del remitente",this.errorValidator,11);
      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr4)), 'Ingrese el representante legal', this.errorValidator, 12);

    }

    if (this.flgMonitores) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(this.numIdNumOtr1 != null), 'Ingrese el número de ficha de monitor', this.errorValidator, 13);

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr3)), 'Ingrese el código de monitor', this.errorValidator, 14);



    }

    if (this.flgMostrarSeccion2) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr4)), 'Ingrese el cargo del remitente', this.errorValidator, 10);

    }

    if (this.flgMostrarSeccion1) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(this.numIdNumOtr1 != null), 'Ingrese el ' + this.strDscEtiqSecc1, this.errorValidator, 15);

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(this.numIdTipDocExp != null), 'Ingrese el tipo de ciudadano', this.errorValidator, 17);

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr4)), 'Ingrese el nombre del ciudadano', this.errorValidator, 18);


    }

    if (this.flgBD) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr3)), 'Ingrese el nombre de la base de datos', this.errorValidator, 19);

    }

    if (this.flgServControl) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(this.numIdTipDocExp != null), 'Ingrese el tipo servicio control', this.errorValidator, 20);

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr3)), 'Ingrese la modalidad de servicio de control', this.errorValidator, 21);

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(this.numIdNumOtr1 != null), 'Ingrese el numero de orden de servicio', this.errorValidator, 22);

    }

    if (!this.flgCorreoElec) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr)), 'Ingrese la sumilla', this.errorValidator, 30);

    }

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strDscRegOtr2)), 'Ingrese el detalle', this.errorValidator, 31);

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex(!(isNotEmpty(this.strFchRecep)), 'Ingrese la fecha de recepción', this.errorValidator, 32);


    // this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((this.numIdCanal != null ? false:true), "Ingrese el tipo de documento",this.errorValidator,1);

    // this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((this.strDscAsunto.length > 0 ? false:true), "Ingrese el asunto",this.errorValidator,1);

    // if(this.flgCorreoElec || this.flgCarta)
    // {

    //   dscRemitente = this.strDscRemitente;

    //   this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((dscRemitente.length > 0 ? false:true), "Ingrese el remitente",this.errorValidator,2);

    //   this.dscRegotr = dscRemitente;

    // }

    // if(this.flgCorreoElec)
    // {

    //   dscCorreo = this.strDscCorreo;

    //   this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((dscCorreo.length > 0 && ValidarEmail(dscCorreo) ? false : true), "Ingrese el correo",this.errorValidator,3);

    //   this.dscRegotr2 = dscCorreo;

    // }

    // if(this.flgRepPrensa)
    // {

    //   dscSumilla = this.strDscSumilla;
    //   dscDetPrensa = this.strDscDetPrensa;
    //   dscNomProg = this.strDscNomProg;

    //   this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((dscSumilla.length > 0 ? false : true), "Ingrese la sumilla",this.errorValidator,4);

    //   this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((dscDetPrensa.length > 0 ? false : true), "Ingrese el detalle de prensa",this.errorValidator,5);

    //   this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((dscNomProg.length > 0 ? false : true), "Ingrese el nombre del programa",this.errorValidator,6);

    //   this.dscRegotr = dscSumilla;
    //   this.dscRegotr2 = dscDetPrensa;
    //   this.dscRegotr3 = dscNomProg;

    // }

    // console.log("=================this.strFchRecep");
    // console.log(this.strFchRecep);

    // this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((this.strFchRecep.length > 0 ? false : true), "Ingrese la fecha de recepción",this.errorValidator,7);

    if (this.mFuncErrorVal.RevisarErrorValidator(this.errorValidator)) {

      // console.log("===============ERROR");
      // console.log(this.errorValidator);

      FlgError = true;

    }

    // nsole.log("=========0FINAL");

    return FlgError;

  }

  GuardarDatos() {

    // var numDoc = null;
    let idFur = null;
    let codFur = null;

    this.fur = new Fur();

    this.fur.nfurId = Number(this.strNroRegistro);

    this.fur.strDfurFecregistro = GetDateTime(0, 0);
    this.fur.strDfurFecinicioreg = this.strFechaRegistro + ' ' + this.strHoraReg;
    this.fur.nfurIdcanal = this.numIdCanal;

    this.fur.cfurCodent = this.entidadFur.centCodigo;
    this.fur.cfurCdepent = this.entidadFur.centDirdep;
    this.fur.cfurCprovent = this.entidadFur.centDirpro;
    this.fur.cfurCdistent = this.entidadFur.centDirdis;

    this.fur.nfurIdnumotr1 = this.numIdNumOtr1;
    this.fur.cfurDscregotr5 = this.strDscRegOtr5;
    this.fur.cfurDscregotr3 = this.strDscRegOtr3;
    this.fur.cfurDscregotr4 = this.strDscRegOtr4;
    this.fur.nfurIdtipodocexp = this.numIdTipDocExp;
    this.fur.cfurDscregotr = this.strDscRegOtr;
    this.fur.cfurDscregotr2 = this.strDscRegOtr2;
    this.fur.cfurCoduno = this.strCodUNO;

    this.fur.cfurIdususuperv = GlobalVars.CodPersSuperv;
    this.fur.cfurIdusureg = GlobalVars.CodPersonal;

    this.fur.cfurCodigo = this.strFurCodigo;
    this.fur.booleanCodborrador = false;

    //////////// ENTIDAD

    // this.fur.cfurCodent = this.entidadFur.centCodigo;

    ////////////// ENTIDAD

    // this.fur.dfurFchrecep = this.dateFchRecep;

    // this.fur.strDfurFchrecep = ConvertStrDateToFormatBD(this.strFchRecep);
    this.fur.strDfurFchrecep = GetDateTimeString(this.strFchRecep);

    // this.fur.cfurDschecho = this.strDscAsunto;

    // this.fur.listaDocumentoAdjuntoDet = [];

    // console.log("============this.evidenciasC.listEvidencias");
    // console.log(this.evidenciasC.listEvidencias);

    return new Observable((observer) => {

        console.log('==========this.fur');
        console.log(this.fur);

        // console.log("==========INGRESA SUSCRIBVEE LASER FICHE");
        // console.log(data);

        // this.evidenciasC.listEvidencias.forEach(element => {

        //   this.fur.listaDocumentoAdjuntoDet.push(element);

        // });

        if (!this.flgRegistrar) {

          // console.log("==========ACTUALIZAR");

          this.spinner.show();

          this.furService.ActualizarFur(this.fur).subscribe(data => {

            this.spinner.hide();

            idFur = data.nfurId;
            codFur = data.cfurCodigo;

            if (idFur > 0) {
              this.spinner.show();


            } else {

              openModalMensaje('Expediente', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

              });

              return;

            }

          });

        } else {

          console.log('==========REGISTRAR');
          console.log(JSON.stringify(this.fur));

          this.spinner.show();

          this.furService.RegistrarFur(this.fur).subscribe(data => {

            this.spinner.hide();

            idFur = data.nfurId;
            codFur = data.cfurCodigo;

            if (idFur > 0) {

              this.spinner.show();



            } else {

              openModalMensaje('Expediente', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

                // observer.error();

              });

              // return;

            }

          });

        }

        return () => {
        // Detach the event handler from the target

      };
    });

  }

  // _mensajeOk(idFur:number){

  //   openModalMensaje("Documentos",`Se generó el Documento Nro. ${idFur}, por favor verifique`,this.dialog).afterClosed().subscribe(result=>{

  //     this.strNroRegistro = idFur.toString();
  //     this.opGuardadoOk.emit();

  //   });

  // }

  soloLectura(flgParam: boolean) {

    this.evidenciasC.flgSoloLectura = flgParam;
    this.flgSoloLectura = flgParam;
    this.busqEntidadC.setModoLectura(flgParam);
    if (this.busqEntidadRemitC) {this.busqEntidadRemitC.setModoLectura(flgParam); }

  }

  _descargarPdf() {

    // window.open(this.strDscUrlOfi, '_blank');


    // PROVISIONAL HASTA QUE FUNCIONE EL LASERFICHE
    // console.log(Number(this.strNroRegistro));
    this._generarPlantilla(Number(this.strNroRegistro), false).subscribe(data => {

      console.log('============1111data');
      console.log(data);

      saveContent2(data.dscCampo1, 'Documento.pdf');

    });
    // PROVISIONAL HASTA QUE FUNCIONE EL LASERFICHE

  }


  _generarPlantilla(numIdFur: number, flgProcLF?: boolean) {

    // var vListGeneralFinal:General[] = [];
    const vPlantillaDocumento: PlantillaDocumento = new PlantillaDocumento();
    const vListDocumentoDet: DocumentoDet[] = [];
    let vFur: Fur = null;
    const vGeneralReturn: General = new General();

    flgProcLF = (flgProcLF == null ? true : false);

    vPlantillaDocumento.datos = [];
    // vPlantillaDocumento.tabla = [];

    const plantillaObservable = new Observable<General>(observer => {

      // OBTENGO LOS ULTIMOS DATOS

      this.furService.ObtenerPlantillaFurPorId(numIdFur).subscribe(
        data => {

          vFur = data;

          this.generalPD.listaPdDatos = RecupObjDatosPlant(vFur, this.generalPD.listaPdDatos);

          vPlantillaDocumento.nombreArchivoPlantilla = this.generalPD.dscCampo1;
          vPlantillaDocumento.nombreArchivoGenerado = this.generalPD.dscCampo2;
          vPlantillaDocumento.datos = this.generalPD.listaPdDatos;
          vPlantillaDocumento.grillas = RecuperarGrillasPD('4', vFur.listaDocumentoAdjuntoDet, 1);

          this.spinner.show();

          console.log('===============vPlantillaDocumento');
          console.log(JSON.stringify(vPlantillaDocumento));

          this.externosService.generarDocumento(vPlantillaDocumento).subscribe(
            data => {

              this.spinner.hide();

              if (flgProcLF) {

                vListDocumentoDet[0] = new DocumentoDet();
                vListDocumentoDet[0].cdocumentoCodtipo = CodTipoFichaFUR;
                vListDocumentoDet[0].cdocumentoCodsubtipo = CodSubTipoFichaOFI;
                vListDocumentoDet[0].cdocumentoDscnombre = DscNombreFileOficioFUR;
                vListDocumentoDet[0].strDdocumentoFchreg = GetDateTime(0, 0);
                vListDocumentoDet[0].ndocumentoIdtipd = vFur.nfurId;
                vListDocumentoDet[0].fileBase64 = data.base64;


              } else {

                vGeneralReturn.dscCampo1 = data.base64;
                vGeneralReturn.flgCampo1 = true;

                observer.next(vGeneralReturn);

              }


            },
            err => {

              this.spinner.hide();

              console.log(err);

            });

        });

    });

    return plantillaObservable;

  }

  SetDatos(data: Fur) {

    // console.log("============data RD");
    // console.log(data);

    const numIdCanal = data.nfurIdcanal;


    this.strNroRegistro = data.nfurId.toString();
    this.strHoraReg = RecupPartesFchInicio(data.strDfurFecinicioreg, 1);
    this.strFechaRegistro = RecupPartesFchInicio(data.strDfurFecinicioreg, 2);
    this.numIdCanal = numIdCanal;



    this.strFurCodigo = data.cfurCodigo;

    this.flgRegistrar = false;

    console.log('===============001');

    this._CambioTipDocumento(numIdCanal);
    console.log('===============002');

    this.numIdNumOtr1 = data.nfurIdnumotr1;
    this.strDscRegOtr5 = data.cfurDscregotr5;
    this.strDscRegOtr3 = data.cfurDscregotr3;
    this.strDscRegOtr4 = data.cfurDscregotr4;
    this.numIdTipDocExp = data.nfurIdtipodocexp;
    this.strDscRegOtr = data.cfurDscregotr;
    this.strDscRegOtr2 = data.cfurDscregotr2;

    console.log('===============003');

    this.strFchRecep = ConvertDateTimeToStr2(data.dfurFchrecep);

    console.log('===============004');

    this.busqEntidadC.setEntidad(data.cfurCodent, true); // POR EL EMIT activará _setCodEntidadOut

    console.log('===============005');

    setTimeout(() => {

      if (this.busqEntidadRemitC) {

        this.busqEntidadRemitC.setEntidad(data.cfurCoduno, true); // POR EL EMIT activará _setCodEntidadEmitOut

      }

    }, 1);

    console.log('===============006');

    this.evidenciasC.setEvidenciaC(data);



    console.log('===============007');

    this.strDscUrlOfi = RecupUrlOficio(data.listaDocumentoAdjuntoDet);

  }



}
